<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Promotion Rate</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Promotion Rate</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Promotion Rate</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{ labels.pFactRate_product }}</v-subheader>
                <div class="queryValue">{{ form.pFactRate_product }}</div>
              </v-flex>

              <v-flex xs4>
                <v-subheader class="queryLabel">{{ labels.pFactRate_promotion }}</v-subheader>
                <div class="queryValue">{{ form.pFactRate_promotion }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs4 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.pFactRate_fact1 }}</v-subheader>
                <div class="queryValue">{{ form.pFactRate_fact1 }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-text-field
                  v-model="form.pFactRate_fact1"
                  :label="labels.pFactRate_fact1"
                  :error-messages="errors.collect('pFactRate_fact1')"
                  data-vv-name="pFactRate_fact1"
                  :data-vv-as="labels.pFactRate_fact1"
                  v-validate="'required|max:4'"
                ></v-text-field>
              </v-flex>

              <v-flex xs4 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.pFactRate_fact2 }}</v-subheader>
                <div class="queryValue">{{ form.pFactRate_fact2 }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-text-field
                  v-model="form.pFactRate_fact2"
                  :label="labels.pFactRate_fact2"
                  :error-messages="errors.collect('pFactRate_fact2')"
                  data-vv-name="pFactRate_fact2"
                  :data-vv-as="labels.pFactRate_fact2"
                  v-validate="'required|max:4'"
                ></v-text-field>
              </v-flex>

              <v-flex xs4 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.pFactRate_fact3 }}</v-subheader>
                <div class="queryValue">{{ form.pFactRate_fact3 }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-text-field
                  v-model="form.pFactRate_fact3"
                  :label="labels.pFactRate_fact3"
                  :error-messages="errors.collect('pFactRate_fact3')"
                  data-vv-name="pFactRate_fact3"
                  :data-vv-as="labels.pFactRate_fact3"
                  v-validate="'required|max:4'"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs4 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.pFactRate_fact4 }}</v-subheader>
                <div class="queryValue">{{ form.pFactRate_fact4 }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-text-field
                  v-model="form.pFactRate_fact4"
                  :label="labels.pFactRate_fact4"
                  :error-messages="errors.collect('pFactRate_fact4')"
                  data-vv-name="pFactRate_fact4"
                  :data-vv-as="labels.pFactRate_fact4"
                  v-validate="'required|mask_decimal:2|mask_max_value:9999999999'"
                ></v-text-field>
              </v-flex>

              <v-flex xs4 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.pFactRate_fact5 }}</v-subheader>
                <div class="queryValue">{{ form.pFactRate_fact5 }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-text-field
                  v-model="form.pFactRate_fact5"
                  :label="labels.pFactRate_fact5"
                  :error-messages="errors.collect('pFactRate_fact5')"
                  data-vv-name="pFactRate_fact5"
                  :data-vv-as="labels.pFactRate_fact5"
                  v-validate="'required|mask_decimal:2|mask_max_value:9999999999'"
                ></v-text-field>
              </v-flex>

              <v-flex xs4 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.pFactRate_fact6 }}</v-subheader>
                <div class="queryValue">{{ form.pFactRate_fact6 }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-text-field
                  v-model="form.pFactRate_fact6"
                  :label="labels.pFactRate_fact6"
                  :error-messages="errors.collect('pFactRate_fact6')"
                  data-vv-name="pFactRate_fact6"
                  :data-vv-as="labels.pFactRate_fact6"
                  v-validate="'required|mask_decimal:2|mask_max_value:9999999999'"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.pFactRate_commPct }}</v-subheader>
                <div class="queryValue">{{ form.pFactRate_commPct }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-text-field
                  v-model="form.pFactRate_commPct"
                  :label="labels.pFactRate_commPct"
                  :error-messages="errors.collect('pFactRate_commPct')"
                  data-vv-name="pFactRate_fact4"
                  :data-vv-as="labels.pFactRate_commPct"
                  v-validate="'mask_decimal:2|mask_max_value:99999.99'"
                ></v-text-field>
              </v-flex>

              <v-flex xs4 v-if="queryMode">
                <v-checkbox readonly v-model="form.pFactRate_protComm" :label="labels.pFactRate_protComm"></v-checkbox>
              </v-flex>
              <v-flex xs4 v-else>
                <v-checkbox
                  v-model="form.pFactRate_protComm"
                  :label="labels.pFactRate_protComm"
                  :error-messages="errors.collect('pFactRate_protComm')"
                  data-vv-name="pFactRate_protComm"
                  :data-vv-as="labels.pFactRate_protComm"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>

              <v-flex xs4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.pFactRate_commGN }}</v-subheader>
                <div class="queryValue" v-for="item in filter_pFactRate_commGN" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-autocomplete
                  :label="labels.pFactRate_commGN"
                  :items="pFactRate_commGNList"
                  v-model="form.pFactRate_commGN"
                  item-text="value"
                  item-value="code"
                  data-vv-name="pFactRate_commGN"
                  :data-vv-as="labels.pFactRate_commGN"
                  :error-messages="errors.collect('pFactRate_commGN')"
                  v-validate="'required|max:1'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.pFactRate_discPct }}</v-subheader>
                <div class="queryValue">{{ form.pFactRate_discPct }}</div>
              </v-flex>
              <v-flex xs4 v-else>
                <v-text-field
                  v-model="form.pFactRate_discPct"
                  :label="labels.pFactRate_discPct"
                  :error-messages="errors.collect('pFactRate_discPct')"
                  data-vv-name="pFactRate_discPct"
                  :data-vv-as="labels.pFactRate_discPct"
                  v-validate="'mask_decimal:2|mask_max_value:99999.99'"
                ></v-text-field>
              </v-flex>

              <v-flex xs4 v-if="queryMode">
                <v-checkbox readonly v-model="form.pFactRate_protDisc" :label="labels.pFactRate_protDisc"></v-checkbox>
              </v-flex>
              <v-flex xs4 v-else>
                <v-checkbox
                  v-model="form.pFactRate_protDisc"
                  :label="labels.pFactRate_protDisc"
                  :error-messages="errors.collect('pFactRate_protDisc')"
                  data-vv-name="pFactRate_protDisc"
                  :data-vv-as="labels.pFactRate_protDisc"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container v-if="!newMode" fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn :disabled="queryMode" color="primary" dark class="mr-2" @click="doSave" :loading="submitting">
              {{ newMode ? 'Save' : '' }}{{ reviewMode ? 'Update' : '' }}
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        pFactRate_product: 'Product',
        pFactRate_promotion: 'Promotion',
        pFactRate_fact1: 'Factor 1',
        pFactRate_fact2: 'Factor 2',
        pFactRate_fact3: 'Factor 3',
        pFactRate_fact4: 'Factor 4',
        pFactRate_fact5: 'Factor 5',
        pFactRate_fact6: 'Factor 6',
        pFactRate_commPct: 'Commission %',
        pFactRate_protComm: 'Protect Commission',
        pFactRate_commGN: 'On Gross / Net',
        pFactRate_discPct: 'Discount %',
        pFactRate_protDisc: 'Protect Discount',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        actionKey: 'PROMOTION_FACTOR_RATE',
        pFactRate_product: '',
        pFactRate_promotion: '',
        pFactRate_fact1: '',
        pFactRate_fact2: '',
        pFactRate_fact3: '',
        pFactRate_fact4: '',
        pFactRate_fact5: '',
        pFactRate_fact6: '',
        pFactRate_commPct: 0,
        pFactRate_protComm: true,
        pFactRate_commGN: 'G',
        pFactRate_discPct: 0,
        pFactRate_protDisc: true
      },
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      createdBy: '',
      createdDate: undefined,
      modifiedBy: '',
      modifiedDate: undefined,
      pFactRate_commGNList: [
        { code: 'G', value: 'Gross' },
        { code: 'N', value: 'Net' }
      ]
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.menu.getDetail
      if (apiURI) {
        this.loading = true
        try {
          if (this.objParam === undefined) {
            this.$router.push({
              name: 'promotionRateList',
              params: { from_product: this.$route.params.from_product, from_promo: this.$route.params.from_promo }
            })
          }
          const result = await this.$http.put(apiURI, this.objParam)
          const { data } = result.data
          if (data) {
            this.form.actionKey = data.promoRateDto.actionKey
            this.form.pFactRate_product = data.promoRateDto.pFactRate_product
            this.form.pFactRate_promotion = data.promoRateDto.pFactRate_promotion
            this.form.pFactRate_fact1 = data.promoRateDto.pFactRate_fact1
            this.form.pFactRate_fact2 = data.promoRateDto.pFactRate_fact2
            this.form.pFactRate_fact3 = data.promoRateDto.pFactRate_fact3
            this.form.pFactRate_fact4 = data.promoRateDto.pFactRate_fact4
            this.form.pFactRate_fact5 = data.promoRateDto.pFactRate_fact5
            this.form.pFactRate_fact6 = data.promoRateDto.pFactRate_fact6
            this.form.pFactRate_commPct = data.promoRateDto.pFactRate_commPct
            this.form.pFactRate_protComm = data.promoRateDto.pFactRate_protComm
            this.form.pFactRate_commGN = data.promoRateDto.pFactRate_commGN
            this.form.pFactRate_discPct = data.promoRateDto.pFactRate_discPct
            this.form.pFactRate_protDisc = data.promoRateDto.pFactRate_protDisc
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({
        name: 'promotionRateList',
        params: { from_product: this.form.pFactRate_product, from_promo: this.form.pFactRate_promotion }
      })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
            // } else {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.doCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.doUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.campaignParam.menu
    },
    modeParam() {
      return this.$route.params.paramMode
    },
    objParam() {
      return this.$route.params.paramObjRes
    },
    filter_pFactRate_commGN() {
      return this.pFactRate_commGNList.filter((list) => {
        return list.code === this.form.pFactRate_commGN
      })
    }
  },
  created() {
    if (this.modeParam === 'create') {
      this.newMode = true
      this.form.pFactRate_product = this.objParam.from_product
      this.form.pFactRate_promotion = this.objParam.from_promo
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
  },
  mixins: [MessageMixin]
}
</script>
